import React from 'react';
import { motion } from 'framer-motion';
export function SocialMetrics() {
  const metrics = [{
    value: '+500',
    label: '🇦🇷 estudiantes Argentina confían'
  }, {
    value: '12 + 6',
    label: 'Tomos + Bonos'
  }, {
    value: '4.9/5 ⭐',
    label: '⭐ calificación'
  }];
  return <section className="w-full bg-[#234C40] py-8 md:py-10 px-4" data-id="element-341">
      <div className="max-w-5xl mx-auto" data-id="element-342">
        <div className="grid grid-cols-3 divide-x divide-white/15" data-id="element-343">
          {metrics.map((metric, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="text-center px-2 md:px-6" data-id="element-344">
              <div className="text-xl sm:text-3xl md:text-4xl font-extrabold text-white mb-1 md:mb-2" data-id="element-345">
                {metric.value}
              </div>
              <div className="text-[10px] sm:text-sm md:text-base text-white/70 font-medium leading-snug" data-id="element-346">
                {metric.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}